import React from "react";
import { NavLink } from "react-router-dom";
import { Tag, Box, Image, Text, Button, chakra } from "@chakra-ui/react";
import styled from "@emotion/styled";

type Props = {};

const FONT = "Montserrat, sans-serif";

const _GradientCard = styled(Box)`
  display: flex;
  background: linear-gradient(359.05deg, #3e3e3e 0.72%, #04a7f0 99.1%);
  padding: 2px;
  box-shadow: rgb(0 0 0 / 5%) 0px 6px 10px;
  border-radius: 6px;
`;

const GradientCard = chakra(_GradientCard);

const Home = (props: Props) => {
  return (
    <Box width="100%">
      <Box
        minHeight="640px"
        px={3}
        backgroundImage="url(./assets/home-background.svg)"
        backgroundSize="cover"
        backgroundPosition="top"
        py={20}
        display="flex"
        flexDir="column"
        alignItems="center"
        justifyContent="center"
      >
        <Image
          src="./assets/bwsquare-logo.svg"
          width="360px"
          alt="BWSquare Logo"
          margin="0 auto"
          fill="white"
          pb={5}
        />

        <Text
          color="white"
          fontSize="3xl"
          fontFamily={FONT}
          mb={5}
          textAlign="center"
        >
          The BWS ecosystem aims to democratize access to complex hedge fund
          options strategies and <br />
          to improve its users' portfolio risk-reward characteristics.
        </Text>

        <GradientCard width="300" mx="auto" my="8">
          <Box flex="1" background="rgb(30, 29, 45)" borderRadius="6px" p={5}>
            <Text
              color="white"
              fontSize="xl"
              fontWeight={900}
              display="flex"
              gap={3}
              alignItems="center"
            >
              <Tag colorScheme="blue" p={3}>
                ⚠️
              </Tag>
              <Text color="rgb(140, 140, 227)">
                Under Construction & Coming Soon
              </Text>
            </Text>
          </Box>
        </GradientCard>
      </Box>
      <Box
        width="100%"
        py={5}
        px={3}
        background="rgba(14, 17, 25, 0.5)"
        display="flex"
        flexDir="column"
        justifyContent="center"
        alignItems="center"
      >
        <Text color="white" fontSize="xl" fontFamily={FONT} mb={3}>
          Strategic Partners
        </Text>
        <Box display="flex" gap={10}>
          <Box display="flex" gap={2} justifyContent="center">
            <Image
              src="./assets/DopexLogo.svg"
              width="24px"
              alt="Dopex"
              margin="0 auto"
            />
            <Text color="white" fontWeight="700">
              DOPEX
            </Text>
          </Box>

          <Box display="flex" gap={2} justifyContent="center">
            <Image
              src="./assets/ym-inversed.png"
              height="22px"
              alt="Yield Monitor"
              margin="0 auto"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Home;
